var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("CompanionBox", {
        attrs: {
          msgCompanion: _vm.statusMessage,
        },
        scopedSlots: _vm._u([
          {
            key: "companionActions",
            fn: function fn() {
              return [
                _c(
                  "span",
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$gettext("Bearbeitungszeit")) +
                        "\n                "
                    ),
                    _c("StudipDate", {
                      attrs: {
                        date: _vm.startDate,
                      },
                    }),
                    _vm._v(" - "),
                    _c("StudipDate", {
                      attrs: {
                        date: _vm.endDate,
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.tasks.length > 0
        ? _c("section", [
            _c(
              "table",
              {
                staticClass: "default",
              },
              [
                _c("caption", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Verteilte Aufgaben")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$gettext("Status")))]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(_vm._s(_vm.$gettext("Teilnehmende/Gruppen"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "responsive-hidden",
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Seite")))]
                    ),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$gettext("bearbeitet")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$gettext("Abgabefrist")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$gettext("Abgabe")))]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "responsive-hidden renewal",
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Verlängerungsanfrage")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "responsive-hidden feedback",
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Feedback")))]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.tasks, function (task) {
                    return _c("TaskItem", {
                      key: task.id,
                      attrs: {
                        task: task,
                        taskGroup: _vm.taskGroup,
                      },
                      on: {
                        "add-feedback": function addFeedback(task) {
                          return _vm.$emit("add-feedback", task)
                        },
                        "edit-feedback": function editFeedback(feedback) {
                          return _vm.$emit("edit-feedback", feedback)
                        },
                        "solve-renewal": function solveRenewal(task) {
                          return _vm.$emit("solve-renewal", task)
                        },
                      },
                    })
                  }),
                  1
                ),
              ]
            ),
          ])
        : _c(
            "div",
            [
              _c("CompanionBox", {
                attrs: {
                  mood: "pointing",
                  msgCompanion: _vm.$gettext(
                    "Diese Aufgabe wurde an niemanden verteilt."
                  ),
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }